<template>
  <div>
    <button @click="logout">Logout</button>
  </div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'

export default {
  methods: {
    logout () {
      API.logout()
    }
  }
}
</script>

<style>

</style>
